module.exports = __webpack_public_path__ + "img/Insta.ce46eea5.svg";